import { leftNavigationButton } from '../media/left-navigation-button';

export const getMainMenuStyles = (mainMenu, { palette = {} }) =>
  ({
    mainMenuContainer: {
      transition: 'width 0.2s',
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      flex: '1 1 1px',
      '& .ms-FocusZone': {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: '1 1 1px',
        '& .ReactVirtualized__Grid': {
          '& :focus': {
            border: 'none',
            outline: 'none',
          },
          '&::-webkit-scrollbar': {
            backgroundColor: palette.neutralPrimaryAlt,
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: palette.neutralPrimaryAlt,
            borderRadius: '10px',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '10px',
            backgroundColor: '#C7CACC',
          },
        },
      },
    },
    hidden: {
      display: 'none',
    },
    menuList: {
      listStyle: 'none',
      marginTop: 8,
    },
    divider: {
      borderTop: `solid 1px ${palette.mainMenuHoverBackground}`,
    },
    hideCamapignListButton: {
      height: 47,
      width: '100%',
      paddingLeft: 16,
      color: '#FFFFFF',
      '&:hover': {
        color: '#FFFFFF',
      },
      '&:active': {
        color: '#FFFFFF',
      },
      '&:active .hide-campaign-list-icon': {
        right: 14,
      },
    },
    hideCamapignListIcon: {
      position: 'absolute',
      fontSize: 16,
      right: 18,
    },
    leftNavigationButton: {
      position: 'absolute',
      bottom: '50%',
      left: '100%',
      color: '#FFFFFF',
      height: 94,
      width: 18,
      backgroundImage: leftNavigationButton,
      '&:hover': {
        backgroundImage: leftNavigationButton,
        color: '#FFFFFF',
      },
      '&:focus': {
        backgroundImage: leftNavigationButton,
        color: '#FFFFFF',
      },
    },
    longCampaignAndAdgroupName: {
      '& .ReactVirtualized__Grid__innerScrollContainer': {
        '& .tree-node': {
          height: 'auto',
          '& button.main-menu-tree-node': {
            height: 'auto',
            '& a': {
              height: 'auto',
              width: '100%',
              '& span': {
                height: 'auto',
                display: 'block',
                wordBreak: 'break-word',
                wordWrap: 'break-word',
                whiteSpace: 'normal',
                overflow: 'visible',
                paddingRight: 0,
              },
            },
          },
        },
      },
    },
  });

export const getSideBarStyles = (mainMenu, { palette = {} }) => ({
  sideBarContainer: {
    width: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
  },
  sideBarDarkBackGround: {
    backgroundColor: palette.neutralPrimaryAlt,
  },
  majorComponentsContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
  },
  containerBorder: {
    borderTop: `solid 1px ${palette.mainMenuHoverBackground}`,
    borderRight: `solid 1px ${palette.mainMenuHoverBackground}`,
  },
  hidden: {
    display: 'none',
  },
});

export const getMenuItemListStyles = () => ({
  menuList: {
    listStyle: 'none',
    marginTop: 8,
  },
});
